import { render, staticRenderFns } from "./login-layout-recovery.vue?vue&type=template&id=d0bfdf14&scoped=true&"
import script from "./login-layout-recovery.ts?vue&type=script&lang=ts&"
export * from "./login-layout-recovery.ts?vue&type=script&lang=ts&"
import style0 from "./login-layout-recovery.scss?vue&type=style&index=0&id=d0bfdf14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bfdf14",
  null
  
)

export default component.exports